import { useState, useEffect } from 'react';
import useEventTrace from 'utils/CommonRequestConfig';
import useCampignEventTrace from 'utils/CommonRequestConfigForCampign';

/**This custom hooks is used to onClick event to call api  */
const useAxiosFunction = (props) => {
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState();
  const [error, setError] = useState('');
  const [controller, setController] = useState();
  const {getDefaultReqConfig} = useEventTrace();
  const {getDefaultCampignReqConfig} = useCampignEventTrace();
  const axiosFetch = async configObj => {
    const { axiosInstance, method, url, requestConfig } = configObj;
    try {
      setLoading(true);
      const ctrl = new AbortController();
      setController(ctrl);
      let res="";
      const defaultReqConfig = getDefaultReqConfig();
      const defaultCampignReqConfig = getDefaultCampignReqConfig();
      if (method.toLowerCase()==='get') {
        res = await axiosInstance[method.toLowerCase()](url,{headers:{
          "X-Data-Token": defaultReqConfig,
          "X-cmpgn-tkn" : defaultCampignReqConfig
         }});
      }
      else if(method.toLowerCase()==='delete'){
        res = await axiosInstance[method.toLowerCase()](url,{
          headers: {
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
          },
          ...requestConfig,
          signal: ctrl.signal,
         });
      }
      else{
         res = await axiosInstance[method.toLowerCase()](url,{
          ...requestConfig,
          signal: ctrl.signal,
         },{
          headers: {
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
          }});
      }
      setResponse(res.data);
      return res.data;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
    //console.log("widgetId inside axios hooks testttttttt: ", props?.widgetId);
  };

  useEffect(() => {
    return () => controller && controller.abort();
  }, [controller]);

  return [response, error, loading, axiosFetch];
};

export default useAxiosFunction;
